<template>
  <component
    :is="(isOrdered ? 'ol' : 'ul')"
    class="list"
    :class="{ 'list--ol': isOrdered, 'list--icon': hasIcons, 'list--ul': !hasIcons && !isOrdered}"
  >
    <template v-for="(item, index) in items">
      <li
        :key="index"
        class="list__item"
      >
        <component
          :is="(item.link ? 'a' : 'span')"
          :href="item.link"
          :target="(item.target ? item.target : '_self')"
        >
          <v-icon
            v-if="item.icon && hasIcons"
            class="list__icon"
            :type="item.icon"
          />
          {{ typeof item === 'string' ? item : item.value }}
        </component>
        <List :items="item.items" />
      </li>
    </template>
  </component>
</template>

<script>
  import Icon from '@/atoms/Icon'

  export default {
    name: 'List',
    components: {
      'v-icon': Icon
    },
    props: {
      items: {
        type: Array,
        default: null
      },
      isOrdered: {
        type: Boolean,
        default: false
      },
      hasIcons: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .list {
    $this: &;
    list-style: none;
    padding-left: 0;
    a {
      &,
      &:hover,
      &:focus {
        color: inherit;
        text-decoration: none;
      }
    }
    > #{$this}__item {
      position: relative;
      padding-left: 1.5em;
      word-break: break-word;

      &:before {
        position: absolute;
        left: 0;
      }
    }
    &--ol {
      counter-reset: numbers;
      > :before {
        counter-increment: numbers;
        content: counter(numbers) ".";
        color: $primary;
      }
    }
    &--ul > #{$this}__item:before {
      top: calc((.5em * #{$line-height-base}) - 0.175em);
      height: .35em;
      width: .35em;
      border-radius: 50%;
      background-color: $primary;
      content: '';
    }
    &--icon {
      > #{$this}__item + #{$this}__item {
        margin-top: .5em;
      }
      #{$this}__icon {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
      }
    }
  }


</style>
